import { Championship, Collections, RaceResult } from "api";
import { useCallback, useState } from "react";
import { useFirestore } from "react-redux-firebase";
import { useSnackbar } from "notistack";
import { functions } from "config/firebaseConfig";

interface UseUploadResultsReturn {
    uploadResults: (
        result: RaceResult[],
        raceId: string,
        championship: Championship
    ) => void;
    uploading: boolean;
}

export const useUploadResults = (): UseUploadResultsReturn => {
    const [uploading, setUploading] = useState(false);
    const firestore = useFirestore();
    const { enqueueSnackbar } = useSnackbar();

    const updateResults = useCallback(
        (results: RaceResult[], raceId: string, championship: Championship) => {
            setUploading(true);
            firestore
                .collection(Collections.CHAMPIONSHIP_DRIVERS)
                .where("championshipId", "==", championship.id)
                .get()
                .then((snap) => {
                    const driversByIRacindId = snap.docs
                        .map((doc) => doc.data())
                        .reduce(
                            (previousValue, currentValue) => ({
                                ...previousValue,
                                [currentValue.iracingId ||
                                ""]: currentValue.usedNumber,
                            }),
                            {}
                        );

                    results.forEach(
                        (result) =>
                            (result.carNumber =
                                driversByIRacindId[result.iRacingId] || "")
                    );

                    return results;
                })
                .then((newResults) =>
                    firestore
                        .collection(Collections.RACES)
                        .doc(raceId)
                        .update({ results: newResults })
                )
                .then(() =>
                    functions.httpsCallable("results-calculateStandings")({
                        championshipId: championship.id,
                        raceId,
                    })
                )
                .then(() => {
                    enqueueSnackbar("Resultados atualizados com sucesso!", {
                        variant: "success",
                    });
                })
                .catch((e) => {
                    console.error(e);
                    return enqueueSnackbar(
                        "Não possível atualizar o resultado desta corrida!",
                        { variant: "error" }
                    );
                })
                .finally(() => setUploading(false));
        },
        [enqueueSnackbar, firestore]
    );

    return {
        uploadResults: updateResults,
        uploading,
    };
};
